<template>
    <div class="layout-topbar">
        <div class="layout-topbar-left">
            <a href="#" class="topbar-menu-button" @click="onMenuButtonClick($event)">
                <i class="pi pi-bars"></i>
            </a>
        </div>

        <div class="layout-topbar-center">
            <a @click="redirectRuolo" class="logo-container" v-tooltip.bottom="'Torna alla Dashboard'">
                <img :src="'layout/images/appname-' + (colorScheme === 'light' ? 'dark' : 'light') + '.png'"
                    class="app-logo" />
            </a>
        </div>

        <AppMenu :model="items" :menuMode="menuMode" :colorScheme="colorScheme" :menuActive="menuActive"
            :activeInlineProfile="activeInlineProfile" @sidebar-mouse-over="onSidebarMouseOver"
            @sidebar-mouse-leave="onSidebarMouseLeave" @toggle-menu="onToggleMenu"
            @change-inlinemenu="onChangeActiveInlineMenu" @menu-click="onMenuClick"
            @root-menuitem-click="onRootMenuItemClick" @menuitem-click="onMenuItemClick" />

        <div class="layout-topbar-right">
            <ul class="layout-topbar-right-items">
                <li id="profile" class="profile-item" :class="{ 'active-topmenuitem': topbarMenuActive }">
                    <a href="#" @click="onTopbarItemClick($event, 'profile')" class="profile-link">
                        <div class="user-avatar">
                            <i class="pi pi-user"></i>
                        </div>
                        <i class="pi pi-angle-down dropdown-icon"></i>
                    </a>

                    <ul class="fadeInDown profile-dropdown">
                        <li class="profile-info">
                            <div class="profile-name">{{ nome }} {{ cognome }}</div>
                            <div class="profile-role">{{ ruolo }}</div>
                        </li>
                        <li class="divider"></li>
                        <li role="menuitem">
                            <a href="#" @click="logout">
                                <i class="pi pi-fw pi-sign-out"></i>
                                <span>Logout</span>
                            </a>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import AppMenu from './AppMenu.vue'
    import axios from '@/utilities/Axios.js'
    import VueJwtDecode from 'vue-jwt-decode'
    
    export default {
        emits: ['menu-click', 'menuitem-click', 'root-menuitem-click', 'menubutton-click', 'sidebar-mouse-over', 'sidebar-mouse-leave', 'toggle-menu', 'change-inlinemenu', 'topbar-item-click'],
        data() {
            return {
                activeTopbarItem: null
            }
        },
        props: {
            items: Array,
            menuMode: String,
            colorScheme: String,
            // add a background color to the topbar

            topbarMenuActive: {
                type: Boolean,
                default: false,
            },
            menuActive: {
                type: Boolean,
                default: false,
            },
            activeInlineProfile: {
                type: Boolean,
                default: false,
            },
        },
        computed: {
            token() {
                const token = localStorage.getItem('token')
                if (token) return VueJwtDecode.decode(localStorage.getItem('token'))
                return null
            },
            nickname() {
                return this.token?.nickname
            },
            nome() {
                return this.token?.nome || 'Utente'
            },
            cognome() {
                return this.token?.cognome || ''
            },
            ruolo() {
                return this.token?.ruolo || 'Ospite'
            }
        },
        mounted() {
            console.log('AppTopbar mounted')
        },
        methods: {
            onMenuClick(event) {
                this.$emit('menu-click', event)
            },
            onMenuItemClick(event) {
                this.$emit('menuitem-click', event)
            },
            onRootMenuItemClick(event) {
                this.$emit('root-menuitem-click', event)
            },
            async onMenuButtonClick(event) {
                this.$emit('menubutton-click', event)
            },
            onTopbarItemClick(event, item) {
                if (item == 'profile') {
                    this.$emit('topbar-item-click', event, item)
                    event.preventDefault()
                    return
                }
                event.preventDefault()
            },
            onSidebarMouseOver() {
                this.$emit('sidebar-mouse-over')
            },
            onSidebarMouseLeave() {
                this.$emit('sidebar-mouse-leave')
            },
            onToggleMenu(event) {
                this.$emit('toggle-menu', event)
            },
            onChangeActiveInlineMenu() {
                this.$emit('change-inlinemenu')
            },
            isOverlay() {
                return this.menuMode === 'overlay'
            },
            async logout() {
                const subscription = localStorage.getItem('pushSubscription')
                if (subscription) {
                    await axios.post('/webpush', {
                        action: 'unsubscribe',
                        subscription: JSON.parse(subscription)
                    });
                }
                localStorage.removeItem('token')
                this.$router.replace({ path: '/login' })
            },
            redirectRuolo() {
                const token = VueJwtDecode.decode(localStorage.getItem('token'));
                const nickname = token.nickname;
                const ruolo = token.ruolo;

                // Prima controlla se c'è una regola per il nickname
                if (this.redirectNickname(nickname)) {
                    return; // Se c'è una regola per il nickname, termina qui
                }

                // Se non c'è una regola per il nickname, procedi con la logica basata sul ruolo
                switch (ruolo) {
                    case 'Sviluppatore':
                        this.$router.push('/scrivaniadirezionale')
                        break
                    case 'Direzione':
                        this.$router.push('/scrivaniadirezionale')
                        break
                    case 'Direzione Commerciale':
                        this.$router.push('/direzione')
                        break
                    case 'Amministrazione':
                        this.$router.push('/amministrazione')
                        break
                    case 'Ufficio Acquisti':
                        this.$router.push('/ufficioacquisti')
                        break
                    case 'Ufficio Tecnico':
                        this.$router.push('/dashboardufficiotecnico')
                        break
                    case 'Magazzino Martina':
                    case 'Magazzino Martina Amm':
                        this.$router.push('/scrivaniamagazzinomartina')
                        break
                    default:
                        this.$router.push('/')
                        break
                }
            },
            redirectNickname(nickname) {
                switch (nickname) {
                    case 'g.romanelli':
                        this.$router.push('/scrivaniadirezionale')
                        return true
                    case 'f.azzinnari':
                        this.$router.push('/fabrizioazzinnari')
                        return true
                    case 'p.zizzi':
                        this.$router.push('/scrivaniadirezionale')
                        return true
                    default:
                        return false
                }
            }
        },
        components: {
            AppMenu,
        },
    }
</script>
<style scoped>
    /* Layout Topbar */
    .layout-topbar {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 1.5rem;
        position: relative;
    }

    .layout-topbar-left {
        display: flex;
        align-items: center;
    }

    .layout-topbar-center {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        align-items: center;
    }

    .layout-topbar-right {
        display: flex;
        align-items: center;
    }

    /* Logo Center */
    .logo-container {
        cursor: pointer;
        padding: 0.5rem 1rem;
        border-radius: 12px;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        display: flex;
        align-items: center;
    }

    .logo-container:hover {
        background: rgba(var(--primary-color-rgb), 0.1);
        transform: scale(1.05);
    }

    .app-logo {
        height: 32px;
        width: auto;
        max-width: none;
        max-height: 40px;
        object-fit: contain;
        display: block;
        transition: all 0.3s ease;
    }

    /* Profile Section */
    .profile-link {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        padding: 0.5rem 0.75rem;
        border-radius: 50px;
        transition: all 0.3s ease;
        cursor: pointer;
        border: 2px solid transparent;
        box-sizing: border-box; /* prevent layout shift when border/outline applied */
    }

    .profile-link:hover {
        background: rgba(var(--primary-color-rgb), 0.06);
        /* avoid changing border-width/color to prevent shift; use box-shadow for emphasis */
        box-shadow: 0 0 0 3px rgba(var(--primary-color-rgb), 0.06);
    }

    .dropdown-icon {
        font-size: 0.9rem;
        color: var(--text-color-secondary);
        transition: transform 0.3s ease;
    }

    .profile-item.active-topmenuitem .dropdown-icon {
        transform: rotate(180deg);
    }

    .user-avatar {
        width: 45px;
        height: 45px;
        min-width: 45px;
        min-height: 45px;
        flex: 0 0 45px;
        box-sizing: border-box;
        border-radius: 50%;
        background: #ffffff; /* sfondo bianco richiesto */
        display: flex;
        align-items: center;
        justify-content: center;
        color: var(--primary-color); /* mantieni colore primario PrimeVue */
        font-size: 1.4rem;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
        transition: all 0.3s ease;
        border: 2px solid var(--primary-color); /* bordo che richiama lo stile primario */
    }

    /* Ensure the icon inside the avatar is centered and not stretched */
    .user-avatar i {
        display: inline-block;
        line-height: 1;
        font-size: 1.2rem;
        color: var(--primary-color);
    }

    .profile-link:hover .user-avatar {
        transform: none; /* avoid scaling which can overlap dropdown */
        box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
    }

    /* Profile Dropdown */
    .profile-dropdown {
        min-width: 220px;
        border-radius: 12px;
        overflow: hidden;
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
    }

    .profile-info {
        padding: 1rem 1.5rem;
        background: linear-gradient(135deg, rgba(var(--primary-color-rgb), 0.1), rgba(var(--primary-color-rgb), 0.05));
        border-bottom: 1px solid rgba(0, 0, 0, 0.05);
    }

    .profile-name {
        font-weight: 700;
        font-size: 0.95rem;
        color: var(--text-color);
        margin-bottom: 0.25rem;
    }

    .profile-role {
        font-size: 0.8rem;
        color: var(--text-color-secondary);
        text-transform: uppercase;
        letter-spacing: 0.5px;
        font-weight: 600;
    }

    .divider {
        height: 1px;
        background: rgba(0, 0, 0, 0.05);
        margin: 0;
    }

    .profile-dropdown li a {
        padding: 0.75rem 1.5rem;
        display: flex;
        align-items: center;
        gap: 0.75rem;
        transition: all 0.2s ease;
        font-weight: 500;
    }

    .profile-dropdown li a:hover {
        background: rgba(var(--primary-color-rgb), 0.1);
        padding-left: 1.75rem;
    }

    .profile-dropdown li a i {
        font-size: 1.1rem;
        color: var(--primary-color);
    }

    /* Mobile Responsive */
    @media (max-width: 991px) {
        .layout-topbar {
            padding: 0 1rem;
        }

        .layout-topbar-center {
            position: static;
            transform: none;
            flex: 1;
            justify-content: center;
        }

        .dropdown-icon {
            display: none;
        }

        .profile-link {
            padding: 0.5rem;
        }

        .user-avatar {
            width: 40px;
            height: 40px;
            font-size: 1.1rem;
        }

        .app-logo {
            height: 28px;
            width: auto;
            object-fit: contain;
            max-height: 36px;
        }
    }

    @media (max-width: 576px) {
        .app-logo {
            height: 24px;
            width: auto;
            object-fit: contain;
            max-height: 32px;
        }
    }
</style>
